// api
import api from '@/utilities/api'

import {
	Auth
} from 'aws-amplify'

// pulls the logged in contact's licenses out of FileMaker. shared by the Licensing page and the
// sidebar, which asks only to decide whether a customer without FM still gets the menu item
export async function fetchLicenses(): Promise<Array<any>> {
	const user = await Auth.currentAuthenticatedUser()
	const body = {
		action: "licenseList",
		payload: {
			id: user.attributes['custom:fm_contact_id']
		}
	}

	const response = await api("post", "fmDataAPI", "/fmDataAPI", body)
	const scriptResult = JSON.parse(response.response.scriptResult)

	return scriptResult.result.data.licenses ?? []
}
